var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.666748C4.3172 0.666748 1.33333 3.65062 1.33333 7.33341C1.33333 11.0162 4.3172 14.0001 8 14.0001C11.6828 14.0001 14.6667 11.0162 14.6667 7.33341C14.6667 3.65062 11.6828 0.666748 8 0.666748ZM8 12.7098C5.02957 12.7098 2.62366 10.3038 2.62366 7.33341C2.62366 4.36298 5.02957 1.95707 8 1.95707C10.9704 1.95707 13.3763 4.36298 13.3763 7.33341C13.3763 10.3038 10.9704 12.7098 8 12.7098ZM9.66129 9.90331L7.37903 8.2447C7.2957 8.18288 7.24731 8.0861 7.24731 7.98395V3.56997C7.24731 3.39255 7.39247 3.24739 7.56989 3.24739H8.43011C8.60753 3.24739 8.75269 3.39255 8.75269 3.56997V7.37911L10.5484 8.68556C10.6935 8.7904 10.7231 8.99202 10.6183 9.13718L10.1129 9.83341C10.0081 9.97589 9.80645 10.0081 9.66129 9.90331Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9eea77bd75bea3af44e347b2f0d8206c.svg";
export { ForwardRef as ReactComponent };